import { useSelector } from 'react-redux';

const useDisplayedActions = () => {
  const displayedActions = useSelector(state => state.actions.displayedActions);
  return displayedActions;
};
export default useDisplayedActions;
